import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

import BaseComponent from './_BaseComponent'




/* BASE SLIDER
----------------------------------------------------------------------------------------------------*/

export default class Slider extends BaseComponent {

    constructor($el, namespace) {
        super('Slider', $el, namespace)

        this.isTabletOnly = $el.hasClass('tp-slider')

        this.initSlider()
    }


    initSlider() {
        this.swiper = new Swiper(this.$el[0], {
            // General
            slidesPerView: 'auto',
            grabCursor: true,
            speed: 400,


            // Namespace
            containerModifierClass: 'slider--',
            wrapperClass: this.isTabletOnly ? 'tp-slider__wrapper' : 'slider__wrapper',
            slideClass: 'slide',
            slideActiveClass: 'slide--active',
            slideVisibleClass: 'slide--visible',
            slideNextClass: 'slide--next',
            slidePrevClass: 'slide--prev',
            slideDuplicateClass: 'slide--dup',
            slideDuplicateActiveClass: 'slide--dup--active',
            slideDuplicateNextClass: 'slide--dup--next',
            slideDuplicatePrevClass: 'slide--dup--prev',


            // Navigation
            keyboard: true,

            navigation: {
                nextEl: '.latestStories--next',
                prevEl: '.latestStories--prev',
            },


            // Breakpoints
            breakpoints: {
                960: {
                    speed: 700,
                },
            },


            // Callbacks
            on: {
                //
            },
        })
    }
}



